import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { SessionService } from './session/session.service';

enum UserType {
  Customer = "C",
  Representative = "R"
}

declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

interface UserData {
  id?: string;
  type?: UserType;
}

interface ProposalData {
  id?: string;
  value?: number;
  situation?: string;
}

@Injectable({
  providedIn: "root"
})
export class GoogleTagManagerService {

  private userData?: any;
  //private _proposalData?: ProposalData;

  constructor(public session: SessionService) {
    
      this.userData = this.session.getUserData();
  
  }

  push(params: Record<string, any>): void {
    // const appEnvironment = environment.identification;
    // if (!appEnvironment) {
    //   console.warn("Evento do Google Tag Manager não enviado por estar em ambiente local/indefinido.");
    //   return;
    // }

    // window.dataLayer.push({
    //   appEnvironment,
    //   appType: this.getAppTypeDescription(),
    //   userId: this.userData?.id,
    //   userType: this.getUserTypeDescription(this.userData?.type),
    //   visitorLoginState: this.userData?.type ? "Logado" : "Anônimo",
    //   contractID: this._proposalData?.id,
    //   contractValue: this._proposalData?.value,
    //   contractStatus: this._proposalData?.situation,
    //   ...params
    // });
    
  }

  setUserData(data: any | undefined) {
    this.userData = data;
  }

  setProposalData(data: any | undefined) {
   // this.proposalData = data;
  }

  private getAppTypeDescription(): string | undefined {
    return "Web";
  }

  // private getUserTypeDescription(type?: UserType): string | undefined {
  //   if (!type) {
  //     return undefined;
  //   }

  //   if (type === UserType.Customer) {
  //     return "Cliente";
  //   }

  //   if (type === UserType.Representative) {
  //     return "Representante";
  //   }

  //   return "Desconhecido";
  // }
}
